import curry2 from './curry2';

export default curry2(_isSame);

function _isSame<T>(a: T, b: T): boolean {
  return a === b;
}
